import { validate_invalid_characters } from "@/utils/validations";
import { MAIN_CONTROLLER } from "@/utils/main_controller.js";
import { PREPOPULATE_INPUT } from "@/utils/prepopulate_input.js";
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb.vue";
import ClientLogo from "@/components/ClientLogo/ClientLogo.vue";

export default {
  name: 'EnterpriseAMLVerification',
  mixins: [MAIN_CONTROLLER, PREPOPULATE_INPUT],
  components: {
    BreadCrumb,
    ClientLogo
  },
  data: () => ({
    enterprise_name: '',
    json_data: {},
    error_messages: {
      enterprise_name: '',
    },
    isFieldDisabled: false
  }),

  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    }
  },

  methods: {
    validate_enterprise_name() {
      this.enterprise_name = validate_invalid_characters(this.enterprise_name);
    },

    validate_all_fields() {
      let valid = true;
      let message = 'This field is required';

      const fields = ['enterprise_name'];

      fields.forEach((field) => {
        if (!this[field]) {
          this.error_messages[field] = message;
          valid = false;
        } else {
          this.error_messages[field] = '';
        }
      });

      return valid;
    },

    async get_customer_data() {
      const TOKEN = localStorage.getItem('token');
      const CUSTOMER_DATA_URL = `${API_BASE_URL}/verify_api/system_management_api/get_customer_data/`;

      try {
        const response = await $.ajax({
          url: CUSTOMER_DATA_URL,
          method: 'GET',
          contentType: 'application/json',
          headers: {
            Authorization: `Token ${TOKEN}`,
          },
          beforeSend: () => {
            Swal.fire({
              text: 'Loading ...',
              allowEscapeKey: false,
              allowOutsideClick: false,
              didOpen: () => Swal.showLoading(),
            });
          }
        });

        Swal.close();

        // Populate fields and set disabled state based on whether data exists
        this.enterprise_name = response.company_name || '';

      } catch (error) {
        Swal.close();
        console.error('Error fetching customer data:', error);
      }
    },

    enterprise_anti_money_laundering_api() {
      if (!this.validate_all_fields()) {
            return;
      }
      const TOKEN = localStorage.getItem('token');
      const ENTERPRISE_ANTI_MONEY_LAUNDERING_API = `${API_BASE_URL}/verify_api/company_verification/enterprise_anti_money_laundering/`;

      this.error = '';

      $.ajax({
        url: ENTERPRISE_ANTI_MONEY_LAUNDERING_API,
        method: 'POST',
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        data: JSON.stringify({
          enterprise_name: this.enterprise_name,
          workflow_id: this.workflow_id,
          on_behalf_application: this.$route.name === 'behalf_application' ? true : false,
        }),
        beforeSend: () => {
          Swal.fire({
            text: 'Loading ...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
          });
        },
        success: () => {
          Swal.close();
          this.completeService();
        },
        error: (error) => {
          Swal.close();
          let error_message = 'Something went wrong!';

          if (error.responseJSON) {
            error_message = error.responseJSON;
            $('.error-message').text(error_message).removeClass('d-none');
            setTimeout(() => {
              $('.error-message').text('').addClass('d-none');
            }, 3000);
          } else {
            $('.error-message').text(error_message).removeClass('d-none');
            setTimeout(() => {
              $('.error-message').text('').addClass('d-none');
            }, 3000);
          }
        }
      });
    },
  },

  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
    this.get_customer_data();
  }
};
